<template>
  <div class="flex min-h-dvh">
    <CustomerNav />
    <main class="relative min-h-dvh min-w-0 flex-1 overflow-hidden">
      <slot />
    </main>
  </div>
</template>

<script lang="ts">
export default {
  name: 'AppShell',
}
</script>
